/**
 * @file 應用程式入口
 * @description React 應用程式主入口點
 */
import React from 'react';
import ReactDOM from 'react-dom/client';

import store from './store/store';
import { Provider } from 'react-redux';

import './styles/customBootstrap.scss';
import './styles/animate-minimal.css';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
